"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editUserUseCase = void 0;
const users_1 = require("@/services/users");
const users_2 = require("@/store/ducks/users");
const listUsersUseCase_1 = require("./listUsersUseCase");
function editUserUseCase(userId, payload) {
    return async (dispatch) => {
        try {
            dispatch((0, users_2.saveChanges)());
            await (0, users_1.editUser)(userId, payload);
            dispatch((0, users_2.saveChangesSuccess)());
            dispatch((0, users_2.openUserToast)({
                status: "success",
                message: "User edit successfylly.",
            }));
            await (0, listUsersUseCase_1.listUsersUseCase)()(dispatch);
            dispatch((0, users_2.onCloseEditUserModal)());
        }
        catch (error) {
            dispatch((0, users_2.saveChangesError)());
            dispatch((0, users_2.openUserToast)({
                status: "error",
                message: "Error editing user.",
            }));
        }
    };
}
exports.editUserUseCase = editUserUseCase;
